import { render, staticRenderFns } from "./PopularPublishers.vue?vue&type=template&id=ffa39464&"
import script from "./PopularPublishers.vue?vue&type=script&lang=js&"
export * from "./PopularPublishers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports